import { Field } from "../types/types.form";

const formConfig: Field[] = [
  {
    type: "text",
    name: "username",
    label: "username",          
    placeholder: "enterName",   
    required: true,
    defaultValue: "JohnDoe",
  },
  {
    type: "textarea",
    name: "bio",
    label: "bio",
    placeholder: "writeMessage",
    required: false,
    defaultValue: "Full-stack developer",
  },
  {
    type: "date",
    name: "birthDate",
    label: "birthDate",
    required: true,
    defaultValue: "1995-06-15",
  },
  {
    type: "select",
    name: "country",
    label: "country",
    placeholder: "selectCountry",
    required: true,
    options: ["Ukraine", "Poland", "Germany"], 
    defaultValue: "Ukraine",
  },
  {
    type: "multiselect",
    name: "skills",
    label: "skills",
    required: true,
    options: ["React", "TypeScript", "Node.js", "Python"],
    defaultValue: ["React", "TypeScript"],
  },
  {
    type: "file",
    name: "avatar",
    label: "uploadFile",
    placeholder: "chooseFile",
    required: false,
    accept: "image/*",
    multiple: false,
    defaultValue: null,
  },
];

export default formConfig;
